import { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";

import {
  inputFields,
  tables,
  Buttons,
  popover,
  upload,
} from "../../components";

import { UniversityAction } from "../../store/actions";

const Restaurants = () => {
  const dispatch = useDispatch();
  const location = useLocation();

  const id = location.pathname.split("/")[3];

  const { universityAdmin, isLoading } = useSelector(
    (state) => state?.university
  );

  const [state, setState] = useState({
    restaurants: [],
  });

  useEffect(() => {
    setState({
      restaurants: universityAdmin?.restaurants ?? [],
    });
  }, [universityAdmin]);

  const handleRestaurantChange = (index, field, value) => {
    const updatedRestaurants = [...state.restaurants];
    updatedRestaurants[index][field] = value;
    setState({ ...state, restaurants: updatedRestaurants });
  };

  const addRestaurant = () => {
    const newRestaurant = {
      uniID: parseInt(id),
      restaurantName: "",
      distance: "",
      imageURL: "",
    };
    setState({
      ...state,
      restaurants: [...state.restaurants, newRestaurant],
    });
  };

  const removeRestaurant = (index) => {
    const updatedRestaurants = state.restaurants.filter((_, i) => i !== index);
    setState({ ...state, restaurants: updatedRestaurants });
  };

  const handleSubmit = () => {
    const payload = {
      id: parseInt(id),
      page: "restaurants",
      data: state,
    };

    dispatch(
      UniversityAction.editUniversity(payload, () => {
        dispatch(UniversityAction.getUniversityDetailsAdmin(id));
      })
    );
  };

  const columns = [
    {
      title: "#",
      dataIndex: "#",
      width: 40,
      render: (text, record, index) => index + 1,
    },
    {
      title: "Name",
      dataIndex: "restaurantName",
      width: 400,
      render: (text, record, index) => (
        <inputFields.DefaultInput
          value={text}
          onChange={(e) =>
            handleRestaurantChange(index, "restaurantName", e.target.value)
          }
        />
      ),
    },
    {
      title: "Distance (km)",
      dataIndex: "distance",
      width: 350,
      render: (text, record, index) => (
        <inputFields.DefaultInput
          value={text}
          type="number"
          onChange={(e) =>
            handleRestaurantChange(index, "distance", e.target.value)
          }
        />
      ),
    },
    {
      title: "Image",
      dataIndex: "imageURL",
      width: 350,
      render: (text, record, index) => (
        <popover.WhitePopover
          content={<img src={text} className="h-[5em] w-full" />}
          trigger="hover"
          placement="top"
        >
          <div>
            <upload.DefaultFileUpload
              onChange={(e) => handleRestaurantChange(index, "imageURL", e)}
              value={text}
              type="image"
              showcrop
            />
          </div>
        </popover.WhitePopover>
      ),
    },
    {
      title: "Actions",
      width: 80,
      render: (_, record, index) => (
        <div>
          <Buttons.RedButton
            size="medium"
            onClick={() => removeRestaurant(index)}
          >
            Remove
          </Buttons.RedButton>
        </div>
      ),
    },
  ];

  return (
    <div className="flex flex-col gap-6">
      <div className="w-[calc(100vw-20em)] overflow-x-auto max-w-full relative">
        <tables.DefaultTable
          dataSource={state.restaurants}
          columns={columns}
          rowKey={(record, index) => index}
          pagination={false}
          loading={isLoading}
        />
      </div>
      <div className="flex gap-5 justify-end">
        <Buttons.DefaultButton size="medium" onClick={addRestaurant}>
          Add Restaurant
        </Buttons.DefaultButton>
        <Buttons.DefaultButton size="medium" onClick={handleSubmit}>
          Save Changes
        </Buttons.DefaultButton>
      </div>
    </div>
  );
};

export default Restaurants;
